import React, { useState, useEffect, useContext } from 'react';
import { ApiService } from '../Axios/ApiService';
import { ProductOptionRefContext } from '../Providers/ProductOptionRefProvider';
import { TranslationContext } from '../Providers/TranslationProvider';

const useProductOptionSteps = (productId,defaultoptions) => {

    const { scrollToStep } = useContext(ProductOptionRefContext);
    const { trans } = useContext(TranslationContext);
    const [steps, setSteps] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    const [printPrices, setPrintPrices] = useState(false);
    const [offsetPrices, setOffsetPrices] = useState(false);
    const [selectedOption, setSelectedOption] = useState(false);
    const [sku, setSku] = useState(false);

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        const s = getSkuFromSteps(steps);
        setSku(s);
    }, [steps]);

    const init = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const sku = urlParams.get('sku');

        try {
            setLoading(true);
            const res = (typeof defaultoptions!='undefined' && defaultoptions.length>0) ? JSON.parse(defaultoptions) : await fetchInitailProductOptions(productId);
            let newSteps = (typeof res.data!='undefined') ? mapResponseToSteps(res.data) : mapResponseToSteps(res);
            if(Object.values(newSteps[0]).includes('verspreidgebied')) {
                newSteps = addVerspreidDateDefaultStep(newSteps);
            } else {
                newSteps = addDefaultSteps(newSteps);
            }
            if (sku) {
                const res = await fetchPossibleProductOptions(productId, sku);
                newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
                const prices = mapResponseToPrices(res);
                if (prices) {
                    const [printPrices, offsetPrices] = prices;
                    setPrintPrices(printPrices);
                    setOffsetPrices(offsetPrices);
                }
                setSteps(newSteps);
            }
            newSteps = setStepsDoneIfSelected(newSteps);
            newSteps = markNextStepActive(newSteps, scrollToStep);
            // newSteps = setStepDone('extra_options', newSteps)
            setSteps(newSteps);
            setLoading(false);
        } catch (e) {
            console.log(e.message);
            setError({
                error: e,
                message: trans('error_product_init', true),
            });
            throw e;
        }
    };

    const onSelectProductOption = async (type, value) => {
        try {
            setSelectedOption(false);
            setPrintPrices(false);
            setOffsetPrices(false);
            let newSteps = selectProductOption(type, value, steps);
            newSteps = setStepDone(type, newSteps);
            newSteps = setStepsLoading(newSteps);
            newSteps = markNextStepActive(newSteps, scrollToStep);
            setSteps(newSteps);
            const res = await fetchPossibleProductOptions(
                productId,
                getSkuFromSteps(newSteps)
            );
            newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
            const prices = mapResponseToPrices(res);
            if (prices) {
                const [printPrices, offsetPrices] = prices;
                setPrintPrices(printPrices);
                setOffsetPrices(offsetPrices);
            }
            setSteps(newSteps);
        } catch (e) {
            console.log(e.message);
            setError({
                error: e,
                message: trans('error_product_init', true),
            });
            throw e;
        }
    };

    const onSetStepDone = async type => {
        try {
            setSelectedOption(false);
            setPrintPrices(false);
            setOffsetPrices(false);
            let newSteps = setStepDone(type, steps);
            newSteps = markNextStepActive(newSteps, scrollToStep);
            setSteps(newSteps);

            if (getSkuFromSteps(newSteps) !== '') {
                newSteps = setStepsLoading(newSteps);
                setSteps(newSteps);
                const res = await fetchPossibleProductOptions(
                    productId,
                    getSkuFromSteps(newSteps)
                );
                newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
                const prices = mapResponseToPrices(res);
                if (prices) {
                    const [printPrices, offsetPrices] = prices;
                    setPrintPrices(printPrices);
                    setOffsetPrices(offsetPrices);
                }
                setSteps(newSteps);
            }
        } catch (e) {
            console.log(e.message);
            setError({
                error: e,
                message: trans('error_product_init', true),
            });
            throw e;
        }
    };

    const onSetStepDoneWithoutFetch = type => {
        let newSteps = setStepDone(type, steps);
        newSteps = markNextStepActive(newSteps, scrollToStep);
        setSteps(newSteps);
    };

    const onClearSelectedProductOptions = async type => {
        setSelectedOption(false);
        setPrintPrices(false);
        setOffsetPrices(false);
        let newSteps = clearSelectedProductOptions(type, steps);
        newSteps = setStepsLoading(newSteps);
        newSteps = markNextStepActive(newSteps, scrollToStep);
        setSteps(newSteps);
        if (getSkuFromSteps(newSteps)) {
            const res = await fetchPossibleProductOptions(
                productId,
                getSkuFromSteps(newSteps)
            );
            newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
            setSteps(newSteps);
        } else {
            const res = await fetchInitailProductOptions(productId);
            newSteps = mapResponseToSteps(res.data);
            if(Object.values(newSteps[0]).includes('verspreidgebied')) {
                newSteps = addVerspreidDateDefaultStep(newSteps);
            } else {
                newSteps = addDefaultSteps(newSteps);
            }
            newSteps = markNextStepActive(newSteps, scrollToStep);
            setSteps(newSteps);
        }
    };

    const onSelectPriceAndVariation = (
        type,
        deliveryId,
        variationId,
        quantity,
        productId,
        customPrice
    ) => {
        const [
            newPrintPrices,
            newOffsetPrices,
            selectedOption,
        ] = selectPriceAndVariation(
            type,
            deliveryId,
            variationId,
            quantity,
            productId,
            printPrices,
            offsetPrices,
            customPrice
        );
        setPrintPrices(newPrintPrices);
        setOffsetPrices(newOffsetPrices);
        setSelectedOption(selectedOption);
        onSetStepDoneWithoutFetch('qty');
    };

    const onGetAspectRatio = steps => getAspectRatio(steps);

    const onCheckIfStepIsDone = async type => {
        try {
            //console.log(steps,'incoming steps')
            let [newSteps, stepsDone] = checkFieldsIfStepIsDone(type, steps);
            setSteps(newSteps);
            if (stepsDone) {
                setSelectedOption(false);
                setPrintPrices(false);
                setOffsetPrices(false);
                newSteps = setStepDone(type, newSteps);
                newSteps = setStepsLoading(newSteps);
                newSteps = markNextStepActive(newSteps, scrollToStep);
                setSteps(newSteps);
                const res = await fetchPossibleProductOptions(
                    productId,
                    getSkuFromSteps(newSteps)
                );
                newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
                const prices = mapResponseToPrices(res);
                if (prices) {
                    const [printPrices, offsetPrices] = prices;
                    setPrintPrices(printPrices);
                    setOffsetPrices(offsetPrices);
                }
                setSteps(newSteps);
            }
        } catch (e) {
            console.log(e.message);
            setError({
                error: e,
                message: trans('error_product_init', true),
            });
            throw e;
        }
    };

    const onUpdateProductOptionField = (stepId, skuPart, fieldId, value) => {
        const newSteps = updateProductOptionFields(
            stepId,
            skuPart,
            fieldId,
            value,
            steps
        );
      //  console.log(newSteps,'onUpdateProductOptionField')
        setSteps(newSteps);
    };

    const onClearProductOptionField = (stepId, skuPart, fieldId, value) => {
        const newSteps = clearProductOptionFields(
            stepId,
            skuPart,
            fieldId,
            value,
            steps
        );
        setSteps(newSteps);
    };

    const onSelectOptionCheckboxHandler = async (type, value) => {
        setSelectedOption(false);
        setPrintPrices(false);
        setOffsetPrices(false);
        let newSteps = selectMultipleProductOptions(type, value, steps);
        newSteps = setStepsLoading(newSteps);
        setSteps(newSteps);
        const res = await fetchPossibleProductOptions(
            productId,
            getSkuFromSteps(newSteps)
        );
        newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
        const prices = mapResponseToPrices(res);
        if (prices) {
            const [printPrices, offsetPrices] = prices;
            setPrintPrices(printPrices);
            setOffsetPrices(offsetPrices);
        }
        setSteps(newSteps);
    };

    const onDeselectOptionCheckboxHandler = async (type, value) => {
        setSelectedOption(false);
        setPrintPrices(false);
        setOffsetPrices(false);
        let newSteps = deselectMultipleProductOptions(type, value, steps);
        newSteps = setStepsLoading(newSteps);
        setSteps(newSteps);
        const res = await fetchPossibleProductOptions(
            productId,
            getSkuFromSteps(newSteps)
        );
        newSteps = mergePossibleProductOptionsWithSteps(res, newSteps);
        const prices = mapResponseToPrices(res);
        if (prices) {
            const [printPrices, offsetPrices] = prices;
            setPrintPrices(printPrices);
            setOffsetPrices(offsetPrices);
        }
        setSteps(newSteps);
    };

    return {
        steps,
        error,
        loading,
        onSelectProductOption,
        onSetStepDone,
        onSetStepDoneWithoutFetch,
        onSelectPriceAndVariation,
        printPrices,
        offsetPrices,
        selectedOption,
        onClearSelectedProductOptions,
        sku,
        onUpdateProductOptionField,
        onCheckIfStepIsDone,
        onGetAspectRatio,
        onSelectOptionCheckboxHandler,
        onDeselectOptionCheckboxHandler,
        onClearProductOptionField,
    };
};

export default useProductOptionSteps;

const fetchInitailProductOptions = productId =>
    ApiService.get(`/bestellen/options/${productId}`);

const mapResponseToSteps = res => {
    const defaultOptions = res;
    const steps = [];
    for (const key in defaultOptions) {
        steps.push({
            id: key,
            name: key,
            done: false,
            active: false,
            loading: false,
            type: defaultOptions[key].type,
            description: defaultOptions[key].description,
            step_description: defaultOptions[key].step_description,
            options: defaultOptions[key].options.map(option => ({
                ...option,
                selected: false,
                active: true,
            })),
        });
    }
    return steps;
};

const addDefaultSteps = steps => {
    const enrichedSteps = steps;
    enrichedSteps.push({
        id: 'qty',
        name: 'Oplage',
        description: 'Kies oplage',
        done: false,
        active: false,
        loading: false,
        options: [],
    });
    enrichedSteps.push({
        id: 'overview',
        name: 'Overzicht',
        description: 'Besteloverzicht',
        done: false,
        active: false,
        loading: false,
        options: [],
    });
    return enrichedSteps;
};

const addVerspreidDateDefaultStep = steps => {
    const enrichedSteps = steps;
    enrichedSteps.push({
        id: 'qty',
        name: 'Oplage',
        description: 'Oplage (afgerond)',
        done: false,
        active: false,
        loading: false,
        options: [],
    });
    enrichedSteps.push({
        id: 'overview',
        name: 'Overzicht',
        description: 'Besteloverzicht',
        done: false,
        active: false,
        loading: false,
        options: [],
    });
    return enrichedSteps;
}



const selectProductOption = (type, value, steps) =>
    steps.map(step => {
        if (step.id === type) {
            return {
                ...step,
                options: step.options.map(option => {
                    if (option.value === value) {
                        return {
                            ...option,
                            selected: true,
                        };
                    }
                    return {
                        ...option,
                        selected: false,
                    };
                }),
            };
        }
        return step;
    });

const selectMultipleProductOptions = (type, value, steps) =>
    steps.map(step => {
        if (step.id === type) {
            return {
                ...step,
                options: step.options.map(option => {
                    if (option.value === value) {
                        return {
                            ...option,
                            selected: true,
                        };
                    }
                    return option;
                }),
            };
        }
        return step;
    });

const deselectMultipleProductOptions = (type, value, steps) =>
    steps.map(step => {
        if (step.id === type) {
            return {
                ...step,
                options: step.options.map(option => {
                    if (option.value === value) {
                        return {
                            ...option,
                            selected: false,
                        };
                    }
                    return option;
                }),
            };
        }
        return step;
    });

const setStepDone = (type, steps) =>
    steps.map(step => {
        if (step.id === type) {
            return {
                ...step,
                done: true,
            };
        }
        return step;
    });

const setStepsLoading = steps =>
    steps.map(step => ({
        ...step,
        loading: true,
    }));

const markNextStepActive = (steps, scrollToStep) => {
    let once = false;
    return steps.map(step => {
        if (!step.done && !once) {
            once = true;
            scrollToStep(step.id);
            return {
                ...step,
                active: true,
            };
        }
        return {
            ...step,
            active: false,
        };
    });
};

const fetchPossibleProductOptions = async (productId, sku) =>
    ApiService.post(`/bestellen/${productId}/${sku}`);

const mergePossibleProductOptionsWithSteps = (res, steps, customValue) => {
    const possibleOptions = res.data.product.steps;
    return steps.map(step => {
        if (step.id === 'qty') {
            return {
                ...step,
                loading: false,
                options: step.options,
            };
        }
        return {
            ...step,
            loading: false,
            options: possibleOptions[step.id] || step.options,
        };
    });
};

const getSkuFromSteps = steps => {
    let sku = '';
    steps.forEach(step => {
        if (step.id !== 'qty' || step.id !== 'overview') {
            step.options.forEach(option => {
                if (option.selected) {
                    if (option.fields.length > 0 && option.dynamic) {
                        sku += option.value;
                        sku += '*';

                        option.fields.forEach(field => {
                            sku += `${field.value ? field.value : 'null'}x`;
                        });
                        sku += '-';
                    } else {
                        sku += `${option.value}-`;
                    }
                }
            });
        }
    });
    sku = sku.substring(0, sku.length - 1);
    return sku;
};

const mapResponseToPrices = res => {
    const { prices } = res.data.product;

    let printPrices;
    let offsetPrices;

    if (prices) {
        if (prices.offsetp) {
            offsetPrices = {
                labels: prices.offsetp.levernaam.map((label, i) => ({
                    id: i,
                    ...label,
                })),
                prices: [],
            };
            for (const key in prices.qtyoffset.options) {
                const item = {
                    qty: key,
                    options: [
                        ...prices.qtyoffset.options[key].map(option => ({
                            ...option,
                            ...option.options,
                            options: null,
                            selected: false,
                        })),
                    ],
                };
                offsetPrices.prices = [...offsetPrices.prices, item];
            }
        }
        if (prices.printen) {
            printPrices = {
                labels: prices.printen.levernaam.map((label, i) => ({
                    id: i,
                    ...label,
                })),
                prices: [],
            };
            for (const key in prices.qtyprint.options) {
                const item = {
                    qty: key,
                    options: [
                        ...prices.qtyprint.options[key].map(option => ({
                            ...option,
                            ...option.options,
                            options: null,
                            selected: false,
                        })),
                    ],
                };
                printPrices.prices = [...printPrices.prices, item];
            }
        }
        return [printPrices, offsetPrices];
    }
    return false;
};

const selectPriceAndVariation = (
    type,
    deliveryId,
    variationId,
    quantity,
    productId,
    printPrices,
    offsetPrices,
    customPrice
) => {
    let selectedOption = {
        qty: quantity,
        price_ex: customPrice,
        price_in: customPrice * 1.21,
        variation_id: variationId,
        delivery: deliveryId,
        product_id: productId,
    };
    let newPrintPrices;
    let newOffsetPrices;

    if (type === 'print') {
        if (offsetPrices) {
            newOffsetPrices = {
                ...offsetPrices,
                prices: offsetPrices.prices.map(price => ({
                    ...price,
                    options: price.options.map(option => ({
                        ...option,
                        selected: false,
                    })),
                })),
            };
        }

        newPrintPrices = {
            ...printPrices,
            prices: printPrices.prices.map(price => {
                if (price.qty === quantity) {
                    return {
                        ...price,
                        options: price.options.map(option => {
                            if (
                                option.delivery === deliveryId &&
                                option.variation_id === variationId &&
                                option.product_id === productId
                            ) {
                                selectedOption = {
                                    ...selectedOption,
                                    ...option,
                                };
                                return {
                                    ...option,
                                    selected: true,
                                };
                            }
                            return {
                                ...option,
                                selected: false,
                            };
                        }),
                    };
                }
                return {
                    ...price,
                    options: price.options.map(option => ({
                        ...option,
                        selected: false,
                    })),
                };
            }),
        };
    }
    if (type === 'offset') {
        if (printPrices) {
            newPrintPrices = {
                ...printPrices,
                prices: printPrices.prices.map(price => ({
                    ...price,
                    options: price.options.map(option => ({
                        ...option,
                        selected: false,
                    })),
                })),
            };
        }
        newOffsetPrices = {
            ...offsetPrices,
            prices: offsetPrices.prices.map(price => {
                if (price.qty === quantity) {
                    return {
                        ...price,
                        options: price.options.map(option => {
                            if (
                                option.delivery === deliveryId &&
                                option.variation_id === variationId &&
                                option.product_id === productId
                            ) {
                                selectedOption = {
                                    ...selectedOption,
                                    ...option,
                                };
                                return {
                                    ...option,
                                    selected: true,
                                };
                            }
                            return {
                                ...option,
                                selected: false,
                            };
                        }),
                    };
                }
                return {
                    ...price,
                    options: price.options.map(option => ({
                        ...option,
                        selected: false,
                    })),
                };
            }),
        };
    }

    return [newPrintPrices, newOffsetPrices, selectedOption];
};

const clearSelectedProductOptions = (type, steps) =>
    steps.map(step => {
        if (step.id === type) {
            return {
                ...step,
                done: false,
                options: step.options.map(option => ({
                    ...option,
                    selected: false,
                })),
            };
        }
        return step;
    });

const updateProductOptionFields = (stepId, skuPart, fieldId, value, steps) =>
    steps.map(step => {
        if (step.id === stepId) {
            return {
                ...step,
                options: [
                    ...step.options.map(option => {
                        if (option.value === skuPart) {
                            return {
                                ...option,
                                selected: true,
                                fields: option.fields.map(field => {
                                    if (field.id === fieldId) {
                                        return {
                                            ...field,
                                            value,
                                        };
                                    }
                                    return field;
                                }),
                            };
                        }
                        return {
                            ...option,
                            selected: false,
                        };
                    }),
                ],
            };
        }
        return step;
    });

const clearProductOptionFields = (stepId, skuPart, fieldId, value, steps) =>
    steps.map(step => {
        if (step.id === stepId) {
            return {
                ...step,
                options: [
                    ...step.options.map(option => {
                        if (option.value === skuPart) {
                            return {
                                ...option,
                                selected: false,
                                fields: option.fields.map(field => {
                                    if (field.id === fieldId) {
                                        return {
                                            ...field,
                                            value: false,
                                        };
                                    }
                                    return field;
                                }),
                            };
                        }
                        return {
                            ...option,
                            selected: false,
                        };
                    }),
                ],
            };
        }
        return step;
    });

const checkFieldsIfStepIsDone = (stepId, steps) => {
    const fieldValues = [];
//console.log(steps,'stepsInCheckFields')
    steps.forEach(step => {
        if (step.id === stepId) {
            step.options.forEach(option => {
                option.fields.forEach(field => fieldValues.push(field.value));
            });
        }
    });

    const allValid = fieldValues.every(fieldValue => fieldValue);

    if (allValid) {
        return [
            steps.map(step => {
                if (step.id === stepId) {
                    return {
                        ...step,
                        done: true,
                    };
                }
                return step;
            }),
            true,
        ];
    }
    return [steps, false];
};

const getAspectRatio = steps => {
    let x = null;
    let y = null;
    steps.forEach(step => {
        if (step.id === 'foto_format' || step.id === 'custom_format') {
            step.options.forEach(option => {
                if (option.selected) {
                    option.fields.forEach((field, index) => {
                        if (index === 0) {
                            y = field.value;
                        } else if (index === 1) {
                            x = field.value;
                        }
                    });
                }
            });
        }
    });

    if (x && y) {
        return x / y;
    }
    return null;
};

const setStepsDoneIfSelected = steps =>
    steps.map(step => {
        if (step.options.find(option => option.selected)) {
            return {
                ...step,
                done: true,
            };
        }
        return step;
    });
